<template>
    <v-flex xs12 class="group-view">
        <v-flex v-if="currentCommunityView === userRoles.MEMBER">
            <chapter-page></chapter-page>
        </v-flex>
        <v-flex v-else-if="getRequestedGroups && !hideComponents">
            <GroupConfiguration :isNewGroupRequest="getRequestedGroups"></GroupConfiguration>
        </v-flex>
        <v-flex xs12 v-else-if="currentCommunityView === userRoles.ADMIN">
            <v-flex v-if="getRequestedMembers && !hideComponents">
                <network-joinees @onNetworkJoined="setRequestStatus"></network-joinees>
            </v-flex>
            <v-flex v-else-if="getInviteSomeOne && !hideComponents">
                <InviteSomeone @onInviteSomeoneSuccess="setRequestStatus(NetworkConstants.SUCCESSFULLY_INVITED)" @onInviteSomeoneFail="setRequestStatus(NetworkConstants.ERROR_WHILE_INVITING)"></InviteSomeone>
                <v-flex class="invitation-msg" v-if="requestStatus"><span>{{requestStatus}} <i class="far fa-times-circle"></i></span></v-flex>
            </v-flex>
            <v-flex v-else-if="getManageParticipants && !hideComponents">
                <ManageParticipants></ManageParticipants>
            </v-flex>
            <v-flex v-else-if="getConfigureGroup && !hideComponents">
                <GroupConfiguration></GroupConfiguration>
            </v-flex>
            <v-flex v-else>
                <chapter-page></chapter-page>
            </v-flex>
        </v-flex>
    </v-flex>
</template>

<script>
    import { mapGetters } from "vuex";
    import { userRoles } from '../appCommon.constants';
    import { storeGetters } from '@/store/storeGetters.constant';
    import ChapterPage from "../ChapterPage/ChapterPage.vue";
    import NetworkJoinees from '../NetworkPage/NetworkJoinees';
    import InviteSomeone from '../NetworkPage/InviteSomeone';
    import ManageParticipants from "./ManageParticipants/ManageParticipants";
    import { NetworkConstants } from "../../components/NetworkPage/NetworkConstants";
    import GroupConfiguration from "./GroupConfiguration.vue";
    import { trackPageLoadTime } from '../../common/utils/performance';

    export default {
        name: 'NetworkMain',
        components: {
            ChapterPage,
            NetworkJoinees,
            InviteSomeone,
            ManageParticipants,
            GroupConfiguration,
        },
        data: () => ({
            userRoles,
            requestStatus: '',
            NetworkConstants,
        }),
        mounted() {
            this.$nextTick(() => {
                trackPageLoadTime('NetworkMain');
            });
        },
        methods: {
            setRequestStatus(message) {
                this.requestStatus = message;
                setTimeout(() => {
                    this.requestStatus = '';
                }, 3000);
            },
        },
        computed: {
            ...mapGetters({
                currentCommunityView: `${storeGetters.currentCommunityView}`,
                getRequestedMembers: `network/${storeGetters.getRequestedMembers}`,
                getInviteSomeOne: `network/${storeGetters.getInviteSomeOne}`,
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                getManageParticipants: `network/${storeGetters.getManageParticipants}`,
                getConfigureGroup: `network/${storeGetters.getConfigureGroup}`,
                getRequestedGroups: `network/${storeGetters.getRequestedGroups}`,
            }),
            hideComponents() {
                return this.$route.query && this.$route.query.postId;
            },

        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_commonClasses.scss";
    @import "../../common/styles/_responsive.scss";

    .group-view {
        position: relative;

        .invitation-msg {
            position: absolute;
            top: 0;
            height: 100%;
            width: 100%;
            background: rgba($white, 0.83);
            text-align: center;
            left: 0;
            z-index: 9;

            span {
                position: absolute;
                bottom: -70px;
                left: 50%;
                border: 1px solid rgba($ypo-gray, 0.4);
                border-radius: 4px;
                background-color: $ypo-gold;
                box-shadow: 0 1px 3px 0 rgba($black, 0.18);
                color: $white;
                padding: 15px 45px;
                font-size: 16px;
                font-weight: normal;
                margin-left: -135px;

                i {
                    position: absolute;
                    right: 5px;
                    top: 5px;
                    font-size: 12px;
                    cursor: pointer;
                }
                @include breakpoint(xs) {
                    bottom: inherit;
                    top: 0px;
                }
            }
        }
    }
</style>
